import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

/**
 * Block Coding dropdown for the Space records list.
 *
 * The records list owns the toolbar icon this hangs from, and hands it in as
 * the {@link Component.originSg|origin}.
 */
@ngCore.Component({
  imports: [ds.overlay.attached.Component],
  selector: 'atn-space-records-block-coding',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** The element the dropdown hangs from */
  public readonly originSg = ngCore.input.required<HTMLElement>({
    alias: 'origin',
  })

  /** Whether the dropdown is on screen */
  public readonly presentOverlaySg = ngCore.model(false, {
    alias: 'presentOverlay',
  })

  /** Emits the bulk edit the user picked */
  public readonly optionSelected =
    ngCore.output<state.space.full.records.models.BlockCodingOption>()

  /** Items for the bulk edits Block Coding offers */
  public readonly optionItems =
    state.space.full.records.models.BlockCodingOption.ALL.map(option => ({
      label: state.space.full.records.models.BlockCodingOption.getLabel(option),
      value: option,
    }))
}
